import React, { FunctionComponent } from 'react'

import { getActiveCoverLevelOption, getCurrentQuote } from '../../../../domain'
import { getFeatureToggles, useConfig } from '../../../../state/configuration'
import { useProduct } from '../../ProductProvider'
import { useProposal } from '../ProposalProvider'
import { PaymentDisabled } from './PaymentDisabled'
import { PaymentManager } from './PaymentManager'
import { PaymentPage } from './PaymentPage'

export const PaymentRoute: FunctionComponent = () => {
  const {
    product: { payment },
  } = useProduct()

  const { proposal } = useProposal()
  const { disableBind } = useConfig(getFeatureToggles)

  const quote = getCurrentQuote(proposal)
  const coverLevelOption = getActiveCoverLevelOption(quote)

  const paymentScheduleConfig = payment?.schedules?.find(
    (it) => it.type === coverLevelOption?.paymentScheduleType,
  )

  return paymentScheduleConfig && !disableBind ? (
    <PaymentManager>
      <PaymentPage config={paymentScheduleConfig} />
    </PaymentManager>
  ) : (
    <PaymentDisabled />
  )
}
